const app = {
    init() {
        this.productOverviewHelper();

        this.createClickableTeasers();

        this.createVehicleDetailSwipers();

        this.vehicleContactPopup();
    },

    vehicleContactPopup() {
        if (!$('.single-vehicle').length) {
            return;
        }

        $('.single-vehicle .vehicle-sidebar-footer .contact-button, .single-vehicle .contact-popup, single-vehicle .contact-popup .close-icon').on('click', function (event) {
            if (
                !$(event.target).closest('.popup').length ||
                $(event.target).closest('.close-icon').length
            ) {
                $('body').toggleClass('scroll-lock');
                $('.single-vehicle .contact-popup').toggleClass('active');
            }
        });
    },

    productOverviewHelper() {
        if (!$('.product-overview').length) {
            return;
        }

        const self = this;
        $('.product-overview').parent().css({ background: 'transparent' });

        $('.product-overview .load-more').on('click', function (e) {
            e.preventDefault();

            const btn = $(this);
            const paged = parseInt(btn.attr('data-paged')) + 1;
            const maxPages = btn.data('max-pages');
            const maxResults = btn.data('per-page');
            const container = $('.product-overview .items');

            $.ajax({
                url: wp.ajax,
                type: 'POST',
                data: {
                    action: 'load_more_vehicles',
                    paged: paged,
                    maxResults,
                    nonce: wp.nonce
                },
                success: function (data) {
                    if (data) {
                        if (data == 'No more vehicles found') {
                            btn.remove();
                            return;
                        }

                        container.append(data);
                        btn.text('Laad meer machines')
                        btn.attr('data-paged', paged);
                        self.createClickableTeasers();
                    } else {
                        btn.remove();
                    }
                }
            });
        });
    },

    createClickableTeasers() {
        if (!$('.clickable-teaser').length) {
            return;
        }

        $('.clickable-teaser').on('click', function () {
            window.location = $(this).attr('target');
        });
    },

    createVehicleDetailSwipers() {
        if (!$('.single-vehicle').length) {
            return;
        }

        const vehicleGallery = new Swiper('.single-vehicle .vehicle-gallery', {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });

        const vehicleThumbnail = new Swiper('.single-vehicle .vehicle-thumbnail', {
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: vehicleGallery,
            },
        })
    }
}

$(document).on('ready', $.proxy(app.init(), app));